import React from 'react';
import { useSelector } from 'react-redux';
import './score.scss';

function Score() {
	const score = useSelector((state) => state.score);
	// console.log(score);
	return (
		<div className="sboard">
			<div className="sboard-total" data-iber="false" data-see="1">
				{score.roundsToWin}
			</div>
			<table className="sboard-teams" cellPadding="0" cellSpacing="0" border="0">
				<tbody>
					<tr className="sboard-team">
						<td className="sboard-points"> {score.ourRounds}</td>
						<td className="sboard-score" data-dir="">
							{score.ourPoints}
						</td>
						{/*<td className="sboard-players">
            <div className="p-name" data-afk="1" data-active="0">
              Houcine Awixor
            </div>
            <div className="p-name" data-afk="1" data-active="0">
              Houcine Awixor
            </div>
  </td>*/}
					</tr>
					<tr className="sboard-team">
						<td className="sboard-points"> {score.opponentRounds}</td>
						<td className="sboard-score" data-dir="">
							{score.opponentPoints}
						</td>
						{/*<td className="sboard-players">
            <div className="p-name p-me" data-active="1">
            Houcine Awixor
            </div>
            <div className="p-name" data-afk="1" data-active="0">
            Houcine Awixor
            </div>
</td>*/}
					</tr>
				</tbody>
			</table>
		</div>
	);
}

export default Score;
